import { render, staticRenderFns } from "./ChartGrade.vue?vue&type=template&id=69ec9852&scoped=true&"
import script from "./ChartGrade.vue?vue&type=script&lang=js&"
export * from "./ChartGrade.vue?vue&type=script&lang=js&"
import style0 from "./ChartGrade.vue?vue&type=style&index=0&id=69ec9852&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ec9852",
  null
  
)

export default component.exports